import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-i', 'IconLetterI', [["path",{"d":"M12 4l0 16","key":"svg-0"}]]);